import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import './AiLoadingOverlay.css';

const DEFAULT_PHASES = [
    'Procesando con IA...',
];

/**
 * Overlay reutilizable de animacion IA (neural pulse).
 *
 * Props:
 *  - phases: string[] — textos que ciclan (default: ['Procesando con IA...'])
 *  - interval: number  — ms entre fases (default: 2400)
 *  - inline: boolean    — true = sin overlay absoluto, solo el widget centrado
 *  - size: 'sm' | 'md' — tamaño del anillo (default: 'md')
 */
const AiLoadingOverlay = ({ phases = DEFAULT_PHASES, interval = 2400, inline = false, size = 'md' }) => {
    const [phaseIndex, setPhaseIndex] = useState(0);

    useEffect(() => {
        if (phases.length <= 1) return;
        const timer = setInterval(() => {
            setPhaseIndex(prev => (prev + 1) % phases.length);
        }, interval);
        return () => clearInterval(timer);
    }, [phases, interval]);

    const containerClass = inline ? 'ai-loading-inline' : 'ai-loading-overlay';
    const sizeClass = size === 'sm' ? 'ai-loading--sm' : '';

    return (
        <div className={`${containerClass} ${sizeClass}`}>
            <div className="ai-pulse-container">
                <div className="ai-ring ai-ring-1" />
                <div className="ai-ring ai-ring-2" />
                <div className="ai-ring ai-ring-3" />

                <div className="ai-orbit ai-orbit-1"><div className="ai-dot" /></div>
                <div className="ai-orbit ai-orbit-2"><div className="ai-dot" /></div>
                <div className="ai-orbit ai-orbit-3"><div className="ai-dot" /></div>

                <div className="ai-core">
                    <Sparkles size={size === 'sm' ? 16 : 24} />
                </div>
            </div>

            <AnimatePresence mode="wait">
                <motion.span
                    key={phaseIndex}
                    className="ai-label"
                    initial={{ opacity: 0, y: 6 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -6 }}
                    transition={{ duration: 0.3 }}
                >
                    {phases[phaseIndex]}
                </motion.span>
            </AnimatePresence>
        </div>
    );
};

export default AiLoadingOverlay;
